import _ from 'lodash';
import React from 'react';
import gsap from 'gsap';
import classnames from 'classnames';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(useGSAP);

const { useState, useEffect, useRef } = React;

const AnimateTargetNumber = (props) => {
  const {
    className,
    target = 0,
    duration,
    repeat,
    animate = true,
    width = 10,
    customHeight = null,
    fontSize = 14,
  } = props;
  const height = customHeight ? customHeight : fontSize * 1.25 + 8;
  const divRef = useRef(null);
  useEffect(() => {
    if (animate) {
      gsap
        .to(divRef.current, {
          duration: duration,
          y: -(height * 10),
          ease: 'linear',
          repeat: repeat,
        })
        .then(() => {
          gsap.set(divRef.current, {
            y: 0,
          });
          gsap.to(divRef.current, {
            duration: 1.5, //0.5, // * ((target || 10) + 1),
            y: -(height * (target || 10)),
          });
        });
    }
    return () => {
      gsap.killTweensOf(divRef.current);
    };
  }, [animate]);

  return (
    <div
      style={{
        width: `${width}px`,
        height: `${height}px`,
        fontSize: `${fontSize}px`,
      }}
      className={classnames(
        'relative overflow-hidden font-rubik font-semibold text-[#F16B7C]',
        className
      )}
    >
      <div ref={divRef} className="h-full w-full overflow-visible">
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 0].map((num, idx) => {
          return (
            <div
              key={idx}
              className="flex h-full w-full items-center justify-center"
              style={{
                top: `-${num * 100}%`,
              }}
            >
              <p>{num}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AnimateTargetNumber;
